module.exports = __webpack_public_path__ + "img/icono-degradado.982eea3b.png";